<template>
  <div>
    <div class="flex justify-end">
      <v-icon @click="close" small>mdi-close</v-icon>
    </div>
    <div class="px-10">
      <div class="font-bold text-2xl text-center my-6">
        PASSWORD REQUEST
      </div>

      <div>
        <v-text-field
          v-model="email"
          label="Write your email address here"
        ></v-text-field>
        <!-- <v-text-field
          v-model="thirteen_digit"
          label="Write your 13 digit contract number"
        ></v-text-field> -->
      </div>
      <div
        class="my-6 text-center justify-center flex items-center align-middle w-full"
      >
        <v-btn @click="close" class="mr-2">CANCEL</v-btn>
        <button
          @click="submit_pw_request"
          class="text-white px-2 py-2 w-[100px] rounded-md bg-[#C55A11]"
        >
          SUBMIT
        </button>
      </div>
      <div v-if="progress">
        <v-progress-linear :indeterminate="progress"></v-progress-linear>
      </div>
    </div>

    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="alert_dialog"
      persistent
      :overlay="false"
      max-width="300px"
      transition="dialog-transition"
    >
      <v-card class="p-10">
        <div class="text-center font-noto-sans">
          {{ alert_dialog_text }}
        </div>
        <div class="mt-4">
          <v-btn text class="w-full" @click="close">
            OK
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EventBus from "@/EventBus";
import axios from "axios";
export default {
  data() {
    return {
      alert_dialog: false,
      alert_dialog_text: "",
      thirteen_digit: "",
      progress: false,
      email: "",
      snackbar: false,
      snackbarText: "",
    };
  },
  methods: {
    close() {
      EventBus.$emit("Close_RFP_DIALOG");
      this.clearFields();
    },
    async isValidThirteenDigit(data) {
      const result = await axios.post(
        "/password/check-if-valid-thirteen-digit",
        data
      );
      return result;
    },
    clearFields() {
      this.email = "";
      this.thirteen_digit = "";
    },
    async submit_pw_request() {
      if (!this.email) {
        this.snackbarText = "Please write your email address.";
        this.snackbar = true;
        return;
      } else {
        this.progress = true;
        let data = {
          email: this.email,
          // thirteen_digit: this.thirteen_digit,
        };
        const res = await axios.post("/password/request", data);
        if (res.data.status) {
          this.progress = false;
          this.alert_dialog = true;
          this.alert_dialog_text = res.data.message;
        } else {
          this.progress = false;
          this.alert_dialog = true;
          this.alert_dialog_text = res.data.message;
        }
      }
    },
  },
};
</script>
